<div class="form-group">
    <label class="ui-checkbox input-label">
    <input class="form-control" name="enableTime" type="checkbox" value="{{fieldOptions.enableTime}}"
           (ngModelChange)="dataChangedEvent($event)"
           [(ngModel)]="fieldOptions.enableTime">
    <span><b>Enable time</b></span>
  </label>
</div>